<p-messages
  [(value)]="formattedMessages"
  [key]="key"
  [severity]="severity"
  [closable]="closable"
  [enableService]="enableService"
  [escape]="escape"
  [showTransitionOptions]="showTransitionOptions"
  [hideTransitionOptions]="hideTransitionOptions"
  [styleClass]="cssClass"
  [class.single-message]="$singleMessage()"
>
  @if (template) {
    <ng-template let-message pTemplate="content">
      <ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{ $implicit: message }"> </ng-container>
    </ng-template>
  }
</p-messages>
